<template>
  <v-btn
    size="small"
    variant="outlined"
    :color="color"
    :class="['rounded-sm detail-action-btn', extraClass]"
    :loading="loading"
    :disabled="disabled"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <v-icon v-if="icon" size="small" class="mr-1">{{ icon }}</v-icon>
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  name: 'DetailActionButton',
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    extraClass: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
}
</script>

<style scoped>
.detail-action-btn {
  min-height: 30px;
  text-transform: none;
  letter-spacing: 0.02em;
  font-weight: 600;
}
</style>
